import { useRef, useState } from "react";
import { REPLAY_VIDEO_URL } from "../../replayContent";

const isEmbed = (url) => /youtube\.com|youtu\.be|vimeo\.com|wistia/.test(url || "");

export const ReplayPlayer = ({ onMilestone }) => {
  const videoRef = useRef(null);
  const [fired, setFired] = useState([]);

  const onTimeUpdate = () => {
    const v = videoRef.current;
    if (!v || !v.duration) return;
    const pct = (v.currentTime / v.duration) * 100;
    [25, 50, 75, 100].forEach((m) => {
      if (pct >= (m === 100 ? 99 : m) && !fired.includes(m)) {
        setFired((f) => [...f, m]);
        onMilestone && onMilestone(m);
      }
    });
  };

  if (!REPLAY_VIDEO_URL) {
    return (
      <div
        className="relative w-full rounded-xl border border-[#FE0000]/30 bg-[#182f56] overflow-hidden pulse-border flex flex-col items-center justify-center"
        style={{ aspectRatio: "16/9" }}
        data-testid="replay-player-placeholder"
      >
        <div className="w-16 h-16 rounded-full border-2 border-[#FE0000] flex items-center justify-center mb-6">
          <div className="w-0 h-0 border-y-[10px] border-y-transparent border-l-[16px] border-l-[#FE0000] ml-1" />
        </div>
        <div className="mono text-[13px] tracking-[0.4em] text-[#FFC631]">REPLAY PROCESSING</div>
        <p className="text-sm text-white mt-3 max-w-xs text-center leading-relaxed">
          Your training replay is being prepared. Watch your inbox — it goes live here the moment it&apos;s ready.
        </p>
      </div>
    );
  }

  if (isEmbed(REPLAY_VIDEO_URL)) {
    return (
      <div className="relative w-full rounded-xl border border-white/10 overflow-hidden" style={{ aspectRatio: "16/9" }} data-testid="replay-player-embed">
        <iframe
          src={REPLAY_VIDEO_URL}
          title="Webinar Replay"
          className="absolute inset-0 w-full h-full"
          allow="autoplay; fullscreen; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }

  return (
    <div className="relative w-full rounded-xl border border-white/10 overflow-hidden bg-black" data-testid="replay-player-video">
      <video
        ref={videoRef}
        src={REPLAY_VIDEO_URL}
        controls
        playsInline
        onTimeUpdate={onTimeUpdate}
        className="w-full"
        style={{ aspectRatio: "16/9", accentColor: "#FE0000" }}
      />
    </div>
  );
};
